export const FETCH_STUDENT_INITIAL = "FETCH_STUDENT_INITIAL";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAILURE = "FETCH_STUDENT_FAILURE";
